import {Pie} from "vue-chartjs/legacy"
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

import Constants from '@/constants/Constants.js';

export default {
  name: 'PieChart',
  components: {
    Pie
  },
  props: {
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 200
    },
    chartDataSets: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    chartDataSets:{
      immediate: true,
      handler(newValue) {
        this.chartData.datasets[0].data = newValue
      }
    }
  },
  data() {
    return {
      chartData: {
        labels: Constants.PIE_CHART_DATA.labels,
        datasets: [
          {
            backgroundColor: Constants.PIE_CHART_DATA.color,
            data: []
          }
        ]
      },
      chartOptions: Constants.PIE_CHART_OPTIONS
    }
  }
}